// extracted by mini-css-extract-plugin
module.exports = {"closeIcon":"drawer_closeIcon__Xzgfl","right":"drawer_right__G_Iv2","left":"drawer_left__1g9dX","bottom":"drawer_bottom__GAoeS","top":"drawer_top__Z8C8W"};